<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="backPage"
      [title]="loaded ? dispute.header_text : ''" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-card>
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <tidy-image
            [src]="dispute?.type | disputeIcon"
            class="title-size" />
          <tidy-text
            [header]="dispute?.header_text" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          @if (showActionButtons) {
            <tidy-alert class="yellow-background">
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [body]="'<b>Action Required</b> — Please review and respond'" />
              </tidy-row>
            </tidy-alert>
          } @else if (isPendingResponse) {
            <tidy-alert class="yellow-background">
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [body]="'<b>Pending</b> — Waiting for pro to respond'" />
              </tidy-row>
            </tidy-alert>
          } @else {
            <tidy-alert class="grey-background">
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [body]="'<b>Resolved</b> — No action needed'" />
              </tidy-row>
            </tidy-alert>
          }
        </tidy-row>
        <tidy-divider />
        @for (comment of dispute?.components[0]?.value; track comment; let last = $last) {
          <tidy-row class="extra-top-padding" [ngClass]="!last ? 'extra-bottom-padding' : ''">
            <tidy-text
              [body]="comment?.html" />
          </tidy-row>
          @if (!last) {
            <tidy-divider />
          }
        }
      </tidy-card>

      @if (showActionButtons) {
        <tidy-row class="extra-top-padding extra-bottom-padding">
          <tidy-text
            [helper]="'Choose one of the options below to respond to this dispute.'" />
        </tidy-row>
        <tidy-row [alignLastItemRight]="true">
          <tidy-button
            [text]="'Reject Proposal'"
            [action]="replyCounter.bind(this, 'reject_dispute_counter_proposal')"
            class="secondary" />
          <tidy-button
            [text]="'Accept Proposal'"
            [action]="replyCounter.bind(this, 'accept_dispute_counter_proposal')"
            class="primary" />
        </tidy-row>
      }
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
